// plugins/globalComponents.js

import Vue from 'vue';

// 导入你的组件
import OrderLink from '@/components/global/OrderLink.vue';

// 定义插件对象
const GlobalComponentsPlugin = {
    install(Vue) {
        // 注册全局组件
        Vue.component('OrderLink', OrderLink);
    }
};

// 导出插件对象
export default GlobalComponentsPlugin;



// WEBPACK FOOTER //
// ./src/utils/overallModule.js